import { CardUIExtension, ICardUIExtensionContext } from "tessa/ui/cards";

export class CdRemindersUIExtension extends CardUIExtension {

  public initialized(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    // TODO вроде небыло в вебе
  }
}